module.exports = __webpack_public_path__ + "img/ch16_06_仓库苏醒.3eb02fd9.jpg";